var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiagnosis(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(-20 4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1139",
    "data-name": "Rectangle 1139",
    width: 32,
    height: 32,
    transform: "translate(20 -4)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4557",
    "data-name": "Path 4557",
    d: "M56.194,10.043a.5.5,0,0,1,.145.1l3.334,3.292a.489.489,0,0,1,.1.143H56.688a.492.492,0,0,1-.494-.488V10.043Zm-2.908,8.87a5.191,5.191,0,0,1,5.223,5.158,5.093,5.093,0,0,1-1.05,3.1l1.252,1.237a.679.679,0,0,1,.81.1l3.624,3.579a.658.658,0,0,1,0,.936l-.789.779a.678.678,0,0,1-.947,0l-3.624-3.579a.658.658,0,0,1-.106-.8l-1.252-1.237a5.184,5.184,0,1,1-3.141-9.279Zm0,1.432a3.726,3.726,0,1,0,3.773,3.726A3.75,3.75,0,0,0,53.286,20.345Zm4.9,11.66-1.1-1.087a1.622,1.622,0,0,1-.484-1.174l-.309-.305a6.243,6.243,0,0,1-3.007.765A6.134,6.134,0,1,1,59.5,24.071a6.046,6.046,0,0,1-.775,2.969l.309.305a1.678,1.678,0,0,1,.786.186V14.555H56.688a1.474,1.474,0,0,1-1.482-1.463V10H42.716a.492.492,0,0,0-.494.488V31.517a.492.492,0,0,0,.494.488h15.47ZM48.28,13.114a.246.246,0,0,1,.247.244v1.368h1.385a.246.246,0,0,1,.247.244v1.655a.246.246,0,0,1-.247.244H48.527v1.368a.246.246,0,0,1-.247.244H46.6a.246.246,0,0,1-.247-.244V16.869H44.973a.246.246,0,0,1-.247-.244V14.97a.246.246,0,0,1,.247-.244h1.385V13.358a.246.246,0,0,1,.247-.244Z",
    transform: "translate(-17.222 -10.001)",
    fill: "#09c",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagnosis);
export default __webpack_public_path__ + "static/media/diagnosis.cf929e7c9880737e08ba331dbb2cf418.svg";
export { ForwardRef as ReactComponent };